import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <SectionHeading
          align="center"
          eyebrow="常见问题"
          title="关于神马影院，你可能还想问"
          desc="这里集中回答最常出现的几个疑问，点击任意问题即可展开查看。"
        />

        <div className="mt-9 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-lg border bg-background-50 overflow-hidden transition-colors ${
                  isOpen ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer"
                >
                  <span className="font-heading font-semibold text-foreground-950 text-sm md:text-base">{f.q}</span>
                  <span
                    className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}